import moment from 'moment';

// @ts-expect-error - Automatic, Please fix when editing this file
const formatReleaseEndDate = (releaseEndDate) => moment(releaseEndDate).format('Do of MMMM YYYY');

export default formatReleaseEndDate;
